import { Box, createStyles } from '@mantine/core';

import dt from '~/testing';

import { Avatar } from '../Avatar/Avatar';

type PageHeaderAvatarProps = {
  src: string;
  isSidePanel?: boolean;
  isChatOpen?: boolean;
  chatOffset?: number;
};

type StyleParams = {
  isSidePanel?: boolean;
  isChatOpen?: boolean;
  chatOffset?: number;
};

const useStyles = createStyles(
  (theme, { isSidePanel, isChatOpen = false, chatOffset = 0 }: StyleParams) => ({
    wrapper: {
      width: theme.other.screenWidth.lg,
      marginBottom: theme.spacing.sm,
      position: 'absolute',
      top: 20,
      transition: 'width 0.3s ease-in-out',

      ...(isSidePanel
        ? {
            width: '100%',
            opacity: 1,
          }
        : {
            ...(isChatOpen && {
              width: '100%',
            }),
            [`@media (max-width: ${theme.breakpoints.lg + chatOffset - 1}px)`]: {
              width: '100%',
            },
            [`@media (max-width: ${theme.breakpoints.xs + chatOffset - 1}px)`]: {
              display: 'block',
            },
          }),
    },
    icon: {
      borderRadius: '50%',
      position: 'absolute',
      width: 85,
      height: 85,
      transform: 'translateY(-78px)',
      border: '1px solid white',
      overflow: 'hidden',
      transition:
        'transform 0.35s linear, width 0.35s linear, height 0.35s linear, left 0.3s ease-in-out, margin 0.3s ease-in-out',
      left: isChatOpen ? 58 : 0,
      ...(isSidePanel
        ? {
            width: 72,
            height: 72,
            marginTop: theme.spacing.sm,
          }
        : {
            [`@media (max-width: ${theme.breakpoints.lg + chatOffset - 1}px)`]: {
              transform: 'translateY(-70px)',
              left: 16,
            },
            [`@media (max-width: ${theme.breakpoints.xs + chatOffset - 1}px)`]: {
              transform: 'translateY(-78px)',
            },
            [`@media (max-width: ${theme.breakpoints.md + chatOffset - 1}px)`]: {
              width: 72,
              height: 72,
              marginTop: theme.spacing.sm,
            },
          }),
    },
  })
);

export function PageHeaderAvatar({
  src,
  isSidePanel,
  isChatOpen,
  chatOffset,
}: PageHeaderAvatarProps) {
  const { classes } = useStyles({ isSidePanel, isChatOpen, chatOffset });

  return (
    <Box className={classes.wrapper}>
      <Avatar
        className={classes.icon}
        data-test-id={dt.contestDetail.page.header.thumbnail}
        radius="xl"
        src={src}
        skipNextImageCache
      />
    </Box>
  );
}
